import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  addPodcast,
  episodeStatusChanged,
  getEpiosde,
  getPodcast,
  getPodcastDetail,
} from "../../../features/slices/poadcast";
import {
  getCategoryDropDown,
  getTopicDropDown,
  imageUpload,
} from "../../../features/slices/liveStream";
import { toastService } from "../../../utils/toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import "ckeditor5/ckeditor5.css";
import {
  ListProperties,
  Alignment,
  List,
  Image,
  AutoImage,
  ImageInsert,
  ImageResize, // Add this
  ImageToolbar, // Add this
  ImageStyle, // Add this
  ImageCaption,
  SimpleUploadAdapter,
  Base64UploadAdapter,
} from "ckeditor5";
import QuillEditor from "../../QuillEditor";
import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
} from "ckeditor5";
import LoaderForImage from "../../LoaderForImage";
import DeleteModal from "../../DeleteModal";
import CommonPagination from "../../CommonPagination";
const initialState = {
  podcastName: "",
  categoryId: "",
  topicId: "",
  podcastHostname: "",
  description: "",
  thumbnail: "",
};
const PodcastDetail = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [page, setPage] = useState(1);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const [imageLoader, setImageLoader] = useState(false);
  const {
    categoryId,
    podcastName,
    topicId,
    podcastHostname,
    thumbnail,
    description,
  } = iState;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { episode } = useSelector((state) => state?.podcast);
  useEffect(() => {
    dispatch(getCategoryDropDown()).then((data) => {});
  }, []);
  console.log({ state });

  useEffect(() => {
    if (state) {
      dispatch(getEpiosde({ podcastId: state?._id }));
      setUpdateState((prev) => ({
        ...prev,
        podcastId: state?._id,
        podcastName: state?.podcastName,
        categoryId: state?.categoryData?.[0]?.categoryName,
        topicId: state?.topicData?.[0]?.topicName,
        podcastHostname: state?.podcastHostname,
        description: state?.description,
        thumbnail: state?.thumbnail,
      }));
    }
  }, [state]);
  const { categoryDropDownData, topicDropDowndata } = useSelector(
    (state) => state.liveStream
  );

  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="TitleBox Border">
              <h4 className="Title">View Podcast</h4>
            </div>
            <div className="CommonForm">
              <div className="form-group">
                <label>Podcast Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter podcast name"
                  name="podcastName"
                  value={podcastName}
                  disabled
                />
              </div>
              <div className="form-group">
                <label>Category</label>
                <select
                  className="form-control"
                  name="categoryId"
                  value={categoryId}
                  disabled
                >
                  <option>select</option>
                  {categoryDropDownData?.result?.map((res) => {
                    return (
                      <option value={res?._id}>{res?.categoryName}</option>
                    );
                  })}
                </select>
              </div>
              <div className="form-group">
                <label>Topic</label>
                <select
                  className="form-control"
                  name="topicId"
                  value={topicId}
                  disabled
                >
                  <option>select</option>
                </select>
              </div>
              <div className="form-group">
                <label>Podcast Host Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter podcast name"
                  name="podcastHostname"
                  value={podcastHostname}
                  disabled
                />
              </div>
              <div className="form-group">
                <label>Podcast Description</label>
                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    toolbar: [
                      "undo",
                      "redo",
                      "|",
                      "bold",
                      "italic",
                      "|",
                      "paragraph",
                      "heading1",
                      "heading2",
                      "|",
                      "bulletedList",
                      // "numberedList",
                      "alignment",
                      // "toggleImageCaption",
                      // "imageTextAlternative",
                      // "ckboxImageEdit",
                      // "insertImage",
                      // "imageResize",
                    ],
                    list: {
                      properties: {
                        styles: true,
                        startIndex: true,
                        reversed: true,
                      },
                    },
                    plugins: [
                      List,
                      ListProperties,
                      Bold,
                      Essentials,
                      Italic,
                      Mention,
                      Paragraph,
                      Undo,
                      Alignment,
                      // Image,
                      // AutoImage,
                      // ImageInsert,
                      // ImageResize, // Add this
                      // ImageToolbar, // Add this
                      // ImageStyle, // Add this
                      // ImageCaption,
                      // SimpleUploadAdapter,
                      // Base64UploadAdapter, // Add this
                    ],
                    // image: {
                    //   toolbar: [
                    //     "imageTextAlternative",
                    //     "toggleImageCaption",
                    //     "imageStyle:inline",
                    //     "imageStyle:block",
                    //     "imageStyle:side",
                    //   ],
                    // },
                    // simpleUpload: {
                    //   uploadUrl: "your-server-url-to-handle-image-upload", // Add your upload API here
                    // },
                    mention: {
                      // Mention configuration
                    },
                  }}
                  name="description"
                  disabled
                  data={description}
                /> */}
                <QuillEditor
                  name="description"
                  value={description}
                  disable={true}
                  // Optional custom height
                />
              </div>
            </div>
            <div className="TitleBox Border">
              <h4 className="Title">Podcast Audio &amp; Video</h4>
            </div>
            {imageLoader ? (
              <LoaderForImage />
            ) : (
              <div className="CommonForm">
                <div className="UploadBox Image">
                  <span
                    style={{
                      zIndex: "99",
                    }}
                  >
                    {!thumbnail ? (
                      <img
                        src={require("../../../assets/images/upload-video.png")}
                      />
                    ) : (
                      <>
                        <img
                          src={thumbnail}
                          alt=""
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            mixBlendMode: "darken",
                          }}
                        />
                      </>
                    )}
                  </span>
                </div>
              </div>
            )}

            <div className="TitleBox Border mt-4">
              <h4 className="Title">List of All Episodes</h4>
            </div>
            <div className="TableList">
              {episode?.result?.[0]?.paginationData?.length > 0 ? (
                <table className="table-hover">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Episode Id</th>
                      <th>Episode Name</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {episode?.result?.[0]?.paginationData.map((res, i) => {
                      return (
                        <tr key={res?._id}>
                          <td>{i + 1}</td>
                          <td>{res?.episod_number}</td>
                          <td>{res?.episodName}</td>
                          <td>
                            <span
                              className={`${
                                res?.status == "ACTIVE" ? "Green" : "Red"
                              }`}
                            >
                              {res?.status == "ACTIVE"
                                ? "Available"
                                : "Blocked"}
                            </span>
                          </td>
                          <td>
                            <div className="Actions">
                              <Link
                                to={"/podcast/episodeDetails"}
                                className="Eyes"
                                state={res}
                              >
                                <i className="fa-regular fa-eye" />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <p className="d-flex justify-content-center h-100 text-success">
                  There is no Episode ! please add the Episode
                </p>
              )}
            </div>
            <div className="Pagination">
              {episode?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <>
                  <p>
                    Showing {(page - 1) * 10 + 1} to{" "}
                    {episode?.result?.[0]?.paginationData?.length +
                      (page - 1) * 10}{" "}
                    of {episode?.result?.[0]?.totalCount?.[0]?.count} results
                  </p>
                  <div className="PaginationRight">
                    <CommonPagination
                      activePage={page}
                      itemsCountPerPage={10}
                      totalItemsCount={
                        episode?.result?.[0]?.totalCount?.[0]?.count || 0
                      }
                      pageRangeDisplayed={4}
                      onChange={handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PodcastDetail;
